// src/utils/list.js
export const sortBySeq = (list = []) =>
  [...list].sort((a, b) => {
    if (a.sequence && b.sequence) return a.sequence.localeCompare(b.sequence);
    if (a.sequence) return -1;
    if (b.sequence) return 1;
    return String(a.createdAt || "").localeCompare(String(b.createdAt || ""));
  });

const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

export const arrayMove = (arr, from, to) => {
  const len = arr.length;
  if (!len) return arr;
  const start = clamp(from, 0, len - 1);
  const end = clamp(to, 0, len - 1);
  if (start === end) return arr.slice();
  const copy = arr.slice();
  const [item] = copy.splice(start, 1);
  copy.splice(end, 0, item);
  return copy;
};
